import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const cars = [
  {
    id: 1,
    image: "/img/best-price-car/best-price-car-1-1.png",
    title: "Range Rover - ZF 2016",
    price: "$156,000.00",
  },
  {
    id: 2,
    image: "/img/best-price-car/best-price-car-1-2.png",
    title: "Ferrari - GZ 2033",
    price: "$146,000.00",
  },
  {
    id: 3,
    image: "/img/best-price-car/best-price-car-1-3.png",
    title: "Toyota Camry SE",
    price: "$136,000.00",
  },
  {
    id: 4,
    image: "/img/best-price-car/best-price-car-1-4.png",
    title: "Audi A4 Quattro",
    price: "$166,000.00",
  },
  {
    id: 5,
    image: "/img/best-price-car/best-price-car-1-5.png",
    title: "Hyundai Santa Fe",
    price: "$186,000.00",
  },
  {
    id: 6,
    image: "/img/best-price-car/best-price-car-1-6.png",
    title: "BMW X3 M40i",
    price: "$196,000.00",
  },
];

const BestPriceCar = () => {
  return (
    <section className="best-price-car-sec-1 space-top overflow-hidden">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xxl-7 col-xl-7">
            <div className="title-area text-center">
              <h2 className="sec-title">
                Our Best Reasonable Price Car
              </h2>

              <p>
                Car dealerships typically feature showrooms where
                the latest models are displayed in a well-lit,
                aesthetically pleasing environment.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid px-0">
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          centeredSlides={true}
          spaceBetween={30}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          }}
          className="best-price-car-slider"
        >
          {cars.map((car) => (
            <SwiperSlide key={car.id}>
              <div className="best-price-wrapper">
                {/* Car Image */}
                <div className="best-price-car-gallery-1">
                  <div className="best-price-car-box">
                    <img
                      src={car.image}
                      alt={car.title}
                      className="img-fluid"
                    />
                  </div>
                </div>

                {/* Car Content */}
                <div className="feature-list-1 best-price-car-content mt-4">
                  <div className="car-content text-center">
                    <h6 className="box-title-price">
                      {car.price}
                    </h6>

                    <div className="media-body">
                      <h3 className="box-title">
                        <a href="/single-inventory">
                          {car.title}
                        </a>
                      </h3>
                    </div>

                    <ul className="car-feature justify-content-center">
                      <li>
                        <div className="icon">
                          <img
                            src="/img/icon/car-feature-icon-1-1.svg"
                            alt=""
                          />
                        </div>
                        120cc
                      </li>

                      <li className="divider"></li>

                      <li>
                        <div className="icon">
                          <img
                            src="/img/icon/car-feature-icon-1-2.svg"
                            alt=""
                          />
                        </div>
                        Manual
                      </li>

                      <li className="divider"></li>

                      <li>
                        <div className="icon">
                          <img
                            src="/img/icon/car-feature-icon-1-3.svg"
                            alt=""
                          />
                        </div>
                        Petrol
                      </li>
                    </ul>

                    <div className="car-bottom justify-content-center">
                      <a
                        href="/single-inventory"
                        className="link-btn"
                      >
                        Select Your Car
                        <i className="fas fa-arrow-up-right ms-2"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BestPriceCar;